import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63ac6607"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "言語スキルを教えてください")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_career_text" }, "この項目は任意です", -1))
const _hoisted_5 = { class: "entry_career_input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "英語力")
], -1))
const _hoisted_7 = { class: "entry_career_input_layout_column_1" }
const _hoisted_8 = { class: "entry_career_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "その他言語")
], -1))
const _hoisted_10 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_11 = { class: "entry_career_language_add" }
const _hoisted_12 = { class: "entry_career_button" }
const _hoisted_13 = { class: "entry_career_button_prev" }
const _hoisted_14 = { class: "entry_career_button_next" }
const _hoisted_15 = { class: "entry_career_skip" }

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import Indicator from '@/components/Indicator.vue';
import Loading from '@/components/Loading.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseSelectBox, { Options } from '@/components/BaseSelectBox.vue';
import BaseButton from '@/components/BaseButton.vue';
import { getLangSkill, putLangSkill } from '@/api/careersheetEndpoint';
import { getMasterDataLangSkl, getMasterOtrLang, MasterDataLangSkl } from '@/api/masterDataEndpoint';
import { putUpdateCareerRegstatus } from '@/api/accountEndpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'SkilllanguageView',
  setup(__props) {

const isLoading = ref(false);
const langSklMasterList = ref<MasterDataLangSkl[]>([]);
const otrLangMasterListConvert = ref<Options>([]);
const engsklId = ref('');
const otrLangList = ref(['']);

const init = async () => {
  isLoading.value = true;
  try {
    const [resLangSkill, mstLangSklRes, mstOtrLangRes] = await Promise.all([getLangSkill(), getMasterDataLangSkl(), getMasterOtrLang()]);
    engsklId.value = resLangSkill.engsklId !== null ? String(resLangSkill.engsklId) : '';
    otrLangList.value[0] = resLangSkill.otrlang1Id !== null ? String(resLangSkill.otrlang1Id) : '';
    otrLangList.value[1] = resLangSkill.otrlang2Id !== null ? String(resLangSkill.otrlang2Id) : '';
    otrLangList.value[2] = resLangSkill.otrlang3Id !== null ? String(resLangSkill.otrlang3Id) : '';
    // 初期化処理 otrLangListを後ろから検索 空文字のindexを削除
    for (let idx = otrLangList.value.length - 1; idx >= 0; idx--) {
      if (otrLangList.value[idx] || idx === 0) {
        break;
      }
      if (otrLangList.value[idx] === '') {
        otrLangList.value.splice(idx, 1);
      }
    }
    langSklMasterList.value = mstLangSklRes;
    otrLangMasterListConvert.value = mstOtrLangRes.map((value) => {
      return { value: value.code, label: value.name };
    });
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const LIST_COUNT_LIMIT = 3;
const otrLangListCountLimit = computed(() => {
  return otrLangList.value.length >= LIST_COUNT_LIMIT;
});
const addOtrLangList = () => {
  otrLangList.value.push('');
};

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'c07' });
};
const submitAndTransitionNextPage = async () => {
  isLoading.value = true;
  try {
    await putLangSkill({
      engsklId: engsklId.value ? Number(engsklId.value) : null,
      otrlang1Id: otrLangList.value[0] ? Number(otrLangList.value[0]) : null,
      otrlang2Id: otrLangList.value[1] ? Number(otrLangList.value[1]) : null,
      otrlang3Id: otrLangList.value[2] ? Number(otrLangList.value[2]) : null,
    });
    router.push({ name: 'c09' });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const updateCareerRegstatus = async() => {
  await putUpdateCareerRegstatus();
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 7,
          max: 12
        })
      ]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langSklMasterList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "entry_career_input_layout_column_1_item",
              key: item.code
            }, [
              _createVNode(BaseRadioButton, {
                modelValue: engsklId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((engsklId).value = $event)),
                value: item.code,
                name: "english",
                label: item.name,
                subLabel: item.detail
              }, null, 8, ["modelValue", "value", "label", "subLabel"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otrLangList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "entry_career_input_layout_column_1"
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(BaseSelectBox, {
                options: otrLangMasterListConvert.value,
                modelValue: otrLangList.value[index],
                "onUpdate:modelValue": ($event: any) => ((otrLangList.value[index]) = $event),
                hasCancelButton: "",
                placeholder: "その他言語を選択"
              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_11, [
          (!_unref(otrLangListCountLimit))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: addOtrLangList,
                class: "button_text"
              }, "＋その他言語をさらに入力"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(BaseButton, {
            onClick: submitAndTransitionNextPage,
            theme: "primary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存して次へ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_link, {
          class: "entry_career_skip_link",
          to: { name: 'd00' },
          onClick: updateCareerRegstatus
        }, {
          default: _withCtx(() => [
            _createTextVNode("入力せずに面談予約へ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})